import { render, staticRenderFns } from "./SignaturesTeacher.vue?vue&type=template&id=3e82e7dc&scoped=true"
import script from "./SignaturesTeacher.vue?vue&type=script&lang=js"
export * from "./SignaturesTeacher.vue?vue&type=script&lang=js"
import style0 from "./SignaturesTeacher.vue?vue&type=style&index=0&id=3e82e7dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e82e7dc",
  null
  
)

export default component.exports